import gsap from 'gsap';
import { connectHits } from 'instantsearch.js/es/connectors';
import Swiper, { Manipulation, Navigation } from 'swiper';

Swiper.use([Manipulation, Navigation]);

let slider;

const createSlider = (ele) => (
    new Swiper(ele, {
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1280: {
                slidesPerView: 3,
            },
            1536: {
                centeredSlides: false,
                slidesPerView: 3,
            },
        },
        grabCursor: true,
        loop: true,
        navigation: {
            nextEl: ele.querySelector('.swiper-button-next'),
            prevEl: ele.querySelector('.swiper-button-prev'),
            lockClass: 'opacity-0',
        },
        observer: true,
        slidesPerView: 1,
        spaceBetween: 30,
    })
);

const makeCell = (item) => {
    const cell = document.createElement('a');
    cell.href = item.url;
    cell.className = 'swiper-slide flex flex-col items-center h-auto py-10 px-5 lg:border rounded-xl text-center [&_p]:max-w-72 [&_p]:mx-auto';

    cell.addEventListener('mouseenter', () => {
        gsap.to(cell, {
            duration: 0.2,
            boxShadow: `inset 0 0 0 4px ${item.colour}`,
            borderColor: item.colour,
            ease: 'power2.out',
        });
    });

    cell.addEventListener('mouseleave', () => {
        gsap.to(cell, {
            duration: 0.2,
            boxShadow: 'none',
            borderColor: '#bcbcbc',
            ease: 'power2.out',
        });
    });

    cell.innerHTML = `
        ${item.image ? `
            <img
                src="${item.image}"
                class="w-full max-w-72 px-5 mb-3">
        ` : ''}
        <h2 class="mb-5 text-2xl">
            <img
                src="${item.logo}"
                class="w-full max-w-80 max-h-6 mb-1.5 object-contain">
            <span class="sr-only">${item.title}</span>
        </h2>
        ${item.short_description ? `<p>${item.short_description}</p>` : ''}
        ${item.presale ? `<p class="max-w-48 mt-6 text-xs font-semibold">*${item.presale_message}</p>` : ''}
    `;

    return cell;
};

// create the render function
const renderHits = ({ widgetParams, hits }, isFirstRender) => {
    if (isFirstRender) {
        // init slider
        slider = createSlider(widgetParams.container);
    }

    if (!isFirstRender) {
        // hide slider
        widgetParams.container.classList.add('opacity-0');

        // remove all cells
        slider.removeAllSlides();

        // build cells
        const cells = hits.map(makeCell);

        // add cells
        slider.appendSlide(cells);

        // update slider
        slider.updateSlides();

        // force resize
        setTimeout(() => {
            slider.update();

            // reset slider
            slider.slideTo(0, 0);

            // show slider
            widgetParams.container.classList.remove('opacity-0');
        }, 200);
    }
};

// create the custom widget
const customHits = connectHits(renderHits);

export default customHits;
